function hoursToMinutesInBR(value) {
    const h = parseInt(value);
    let min = ((value - Math.floor(h)) + "").split(".")[1];

    min = (min * 60);

    min = Number.isNaN(min) ? '0' : String(min).substring(0,2);

    const hours = h < 9 ? `0${h}` : h;
    const minute = min < 9 ? `0${min}` : min;

    return `${hours}h ${minute}min`;
}

function formatarDataParaDDMMYYYY(dataString) {
    const data = new Date(dataString);

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();

    return `${dia}-${mes}-${ano}`;
}

function formatarDataParaYYYYMMDD(dataString) {
    const data = new Date(dataString);

    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0');
    const ano = data.getFullYear();

    return `${ano}-${mes}-${dia}`;
}

function formatarParaDDMonYYYY(data) {
    const date = new Date(data);
    const dia = String(date.getDate()).padStart(2, '0');
    const mesesAbreviados = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                             'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const mes = mesesAbreviados[date.getMonth()];
    const ano = date.getFullYear();
    return `${dia}-${mes}-${ano}`;
  }

function extrairMesAno(data) {
    const [dia, mes, ano] = data.split('-');
    return `${mes}-${ano}`;
}


function formatarDataParaMMYYYY(data) {
    const date = new Date(data);
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${mes}/${ano}`;
}

function formatarDataParaYYYYMM(data) {
    const date = new Date(data);
    const mes = String(date.getMonth() + 1).padStart(2, '0');
    const ano = date.getFullYear();
    return `${ano}-${mes}`;
}

/* FORMATAÇÃO DE PERÍODO POR EXTENSO (ex: "2026-01" -> "Janeiro 2026") */
function formatarPeriodoPorExtenso(periodo) {
    const mesesBR = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];
    
    if (!periodo) {
        return "Data inválida";
    }
    
    let ano, mes;
    
    // Se for um objeto Date
    if (periodo instanceof Date) {
        ano = periodo.getFullYear();
        mes = periodo.getMonth() + 1; // getMonth retorna 0-11
    } 
    // Se for uma string
    else if (typeof periodo === "string") {
        // Pode ser "YYYY-MM-DD" ou "YYYY-MM"
        const parts = periodo.split("-");
        
        if (parts.length < 2) {
            return "Data inválida";
        }
        
        ano = parts[0];
        mes = parts[1];
    } 
    else {
        return "Data inválida";
    }
    
    const mesIndex = parseInt(mes, 10) - 1;
    
    if (isNaN(mesIndex) || mesIndex < 0 || mesIndex > 11 || !ano) {
        return "Data inválida";
    }
    
    return `${mesesBR[mesIndex]} ${ano}`;
}

const FormatDataService = {
    hoursToMinutesInBR,
    formatarDataParaDDMMYYYY,
    formatarDataParaYYYYMMDD,
    formatarParaDDMonYYYY,
    extrairMesAno,
    formatarDataParaMMYYYY,
    formatarDataParaYYYYMM,
    formatarPeriodoPorExtenso
}


export default FormatDataService;
